import React from "react";
import OneSectionDefault from "../oneSection/oneSectionDefault";
// Import Anniversary Home Page Images
import annHomeImg1 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__35mm-film-photography-classic-white-anniversary-de__56970.webp';
import annHomeImg2 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__35mm-film-photography-intimate-bedroom-decorated-f__56963.webp';
import annHomeImg3 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56964.webp';
import annHomeImg4 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56965.webp';
import annHomeImg5 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56966.webp';
import annHomeImg6 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56967.webp';
import annHomeImg7 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56968.webp';
import annHomeImg8 from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56969.webp';

// Anniversary Home Page Data Packages
const AnniversaryHomePageDataPackages = [
    {
      id: 1,
      title: "Classic White Anniversary",
      image: annHomeImg1,
      rating: 4.9,
      reviews: 165,
      currentPrice: 1999,
      originalPrice: 2199,
      discount: 9,
      description: "Beautiful classic white anniversary decoration with elegant setup",
      subImage: [
        {
          imageOne: annHomeImg2,
          imageTwo: annHomeImg3,
          imageThree: annHomeImg4,
          imageFour: annHomeImg5,
        }
      ],
    },
    {
      id: 2,
      title: "Intimate Bedroom Anniversary",
      image: annHomeImg2,
      rating: 4.8,
      reviews: 185,
      currentPrice: 2099,
      originalPrice: 2499,
      discount: 16,
      description: "Romantic intimate bedroom decoration for anniversary celebration",
      subImage: [
        {
          imageOne: annHomeImg1,
          imageTwo: annHomeImg3,
          imageThree: annHomeImg4,
          imageFour: annHomeImg6,
        }
      ]
    },
    {
      id: 3,
      title: "Romantic Anniversary Setup",
      image: annHomeImg3,
      rating: 4.7,
      reviews: 145,
      currentPrice: 2199,
      originalPrice: 2499,
      discount: 12,
      description: "Elegant romantic anniversary decoration with premium arrangements",
      subImage: [
        {
          imageOne: annHomeImg1,
          imageTwo: annHomeImg2,
          imageThree: annHomeImg4,
          imageFour: annHomeImg7,
        }
      ]
    },
    {
      id: 4,
      title: "Luxury Anniversary Decor",
      image: annHomeImg4,
      rating: 4.8,
      reviews: 175,
      currentPrice: 2299,
      originalPrice: 2599,
      discount: 12,
      description: "Premium luxury anniversary decoration setup",
      subImage: [
        {
          imageOne: annHomeImg1,
          imageTwo: annHomeImg2,
          imageThree: annHomeImg3,
          imageFour: annHomeImg8,
        }
      ]
    },
    {
      id: 5,
      title: "Elegant Anniversary Celebration",
      image: annHomeImg5,
      rating: 4.9,
      reviews: 195,
      currentPrice: 2399,
      originalPrice: 2799,
      discount: 14,
      description: "Sophisticated elegant anniversary celebration decoration",
      subImage: [
        {
          imageOne: annHomeImg2,
          imageTwo: annHomeImg4,
          imageThree: annHomeImg6,
          imageFour: annHomeImg7,
        }
      ]
    },
    {
      id: 6,
      title: "Premium Anniversary Setup",
      image: annHomeImg6,
      rating: 4.8,
      reviews: 165,
      currentPrice: 2499,
      originalPrice: 2999,
      discount: 17,
      description: "Premium anniversary decoration with luxury elements",
      subImage: [
        {
          imageOne: annHomeImg1,
          imageTwo: annHomeImg3,
          imageThree: annHomeImg5,
          imageFour: annHomeImg8,
        }
      ]
    },
    {
      id: 7,
      title: "Special Anniversary Decor",
      image: annHomeImg7,
      rating: 4.7,
      reviews: 155,
      currentPrice: 2199,
      originalPrice: 2499,
      discount: 12,
      description: "Special anniversary decoration for memorable celebrations",
      subImage: [
        {
          imageOne: annHomeImg2,
          imageTwo: annHomeImg4,
          imageThree: annHomeImg6,
          imageFour: annHomeImg8,
        }
      ]
    },
    {
      id: 8,
      title: "Anniversary Room Setup",
      image: annHomeImg8,
      rating: 4.8,
      reviews: 175,
      currentPrice: 2299,
      originalPrice: 2599,
      discount: 12,
      description: "Complete anniversary room decoration setup",
      subImage: [
        {
          imageOne: annHomeImg1,
          imageTwo: annHomeImg3,
          imageThree: annHomeImg5,
          imageFour: annHomeImg7,
        }
      ]
    }
];

const AnniversarySection = ({ onNavigate }) => {
    return (
        <OneSectionDefault DataPackages={AnniversaryHomePageDataPackages} sectionTitle="Anniversary Decoration" onNavigate={onNavigate} />
    )
};

export default AnniversarySection;